import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import { discussionPlacement } from './utils/sections';

/** Discussion rows read like the portal's article lists: "РАЗДЕЛ · ПОДРАЗДЕЛ" eyebrow above a serif title. */
export default function addDiscussionList() {
  // Coloured tag pills are replaced by the eyebrow below.
  extend(DiscussionListItem.prototype, 'infoItems', function (items) {
    if (items.has('tags')) items.remove('tags');
  });
  extend(DiscussionListItem.prototype, 'statsItems', function (items) {
    items.add('tp-replies-label', m("span", {
      className: "TpStatLabel"
    }, app.translator.trans('tarotportal-theme.forum.stats.replies_word', {
      count: this.attrs.discussion.replyCount()
    })), 60);
  });
  override(DiscussionListItem.prototype, 'mainView', function (original) {
    const vnode = original();
    const {
      section,
      subsection
    } = discussionPlacement(this.attrs.discussion.tags() || []);
    if (section && Array.isArray(vnode?.children)) {
      vnode.children.unshift(m("span", {
        className: "TpListEyebrow"
      }, section.name(), subsection && [m("span", {
        "aria-hidden": "true"
      }, " \xB7 "), subsection.name()]));
    }
    return vnode;
  });
}